import { useAccessibleCard } from '@squiz/xaccel-accessibility';
import React, { useContext } from 'react';
import styles from '../../css/functional.module.scss';
import SearchContext from '../data/FunnelbackContext';

function ListView({ summary, liveUrl, listMetadata, indexUrl, promoted }) {
    const { localStorageState, addFavourite, resetSingleFavourite, addComparison, resetSingleComparison } = useContext(SearchContext);
    const {
        programCredits,
        programCode,
        programTags,
        programLengthYears,
        programLengthCourses,
        programLengthMonths,
        programCredentialName,
        stencilsDepartment,
        programFaculty,
        programCampus,
        stencilsDeliveryMethod,
        programImage,
        programCredentialType,
    } = listMetadata;

    const tags = [
        ...(programCredits || []),
        ...(programCode || []),
        ...(programTags || []),
        ...(programLengthYears || []),
        ...(programLengthCourses || []),
        ...(programLengthMonths || []),
        ...(stencilsDepartment || []),
        ...(programCampus || []),
        ...(stencilsDeliveryMethod || []),
        ...(programCredentialType || []),
    ].filter((tag) => tag !== '0');

    // return a true or false boolean value based on if the obj exists in localStorage already.
    const isSelected = (localStorageArr) => {
        const search = localStorageArr.find((object) => {
            return object.indexUrl === indexUrl;
        });
        return typeof search !== 'undefined';
    };

    const { cardRef, linkRef } = useAccessibleCard();

    // Depending on if the item exists in localStorage, call the function to add or remove it from localStorage.
    const handleLikeButtonClick = () => {
        return isSelected(localStorageState?.favourites)
            ? resetSingleFavourite(indexUrl)
            : addFavourite({ summary, liveUrl, listMetadata, indexUrl, promoted });
    };

    const handleComparisonButtonClick = () => {
        return isSelected(localStorageState?.comparisons)
            ? resetSingleComparison(indexUrl)
            : addComparison({ summary, liveUrl, listMetadata, indexUrl, promoted });
    };

    return (
        <article
            className={`${styles.listViewCard} funnelback-instant-search-list-view__card ${promoted ? styles.listViewCardPromoted : ''}`}
            ref={cardRef}
        >
            <div className={`${styles.listViewCardMain} funnelback-instant-search-list-view__card--main`}>
                <div className={`${styles.listViewCardMainTop} funnelback-instant-search-list-view__card--main-top`}>
                    {programFaculty && <h5>{programFaculty[0]?.toUpperCase()}</h5>}
                    <div className={`${styles.listViewCardShare} funnelback-instant-search-list-view__card--share`}>
                        <button
                            className={isSelected(localStorageState?.comparisons) ? 'comparison-active' : 'comparsion-inactive'}
                            type="button"
                            onClick={() => {
                                handleComparisonButtonClick();
                            }}
                        >
                            Compare
                            <svg>
                                <use href={isSelected(localStorageState?.comparisons) ? '#compare-active-2' : '#compare-2'} />
                                <title>Compare Programs</title>
                            </svg>
                        </button>
                        <button
                            className={isSelected(localStorageState?.favourites) ? 'like-active' : 'like-inactive'}
                            type="button"
                            onClick={() => {
                                handleLikeButtonClick();
                            }}
                        >
                            Like
                            <svg>
                                <use href={isSelected(localStorageState?.favourites) ? '#heart-like-active' : '#heart-like-inactive'} />
                                <title>Like button</title>
                            </svg>
                        </button>
                    </div>
                </div>
                <a href={liveUrl || ''} ref={linkRef}>
                    <h3>{programCredentialName || ''}</h3>
                </a>
                {summary && <p>{summary}</p>}
                <div className={`${styles.listViewCardMainTags} funnelback-instant-search-list-view__card--main-tags`}>
                    {tags.map((tag, i) => {
                        const key = `tag-${i}`;
                        return <p key={key}>{tag}</p>;
                    })}
                </div>
            </div>
            {programImage && (
                <div className={`${styles.listViewCardSecondary} funnelback-instant-search-list-view__card--secondary`}>
                    <a href={liveUrl || ''}>
                        <img src={programImage || ''} alt={programCredentialName || ''} />
                    </a>
                </div>
            )}
        </article>
    );
}

export default ListView;
